import { motion } from 'framer-motion'
import type { PropsWithChildren } from 'react'
import useMeasure from 'react-use-measure'

interface ResizablePanelProps {
	className?: string
}

export const ResizablePanel = ({
	children,
	className,
}: PropsWithChildren<ResizablePanelProps>) => {
	const [ref, { height }] = useMeasure()

	return (
		<motion.div
			animate={{ height }}
			className={className}
		>
			<div ref={ref}>{children}</div>
		</motion.div>
	)
}
